import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { DataService } from "../base-data-services/data.service";
import { SystemService } from "common/services/core-services/system.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { UploadFileModel } from "common/models/page-models/custom-model/uploadfile.model";

@Injectable()
export class documentListDataService extends DataService<UploadFileModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.getDocumentTypeList,http);
    }


//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
    
    createInstance(): UploadFileModel {
        return new UploadFileModel();
    }

}
